export const CtiStatusIconType = {
  ringing: 'ringing',
  calling: 'calling',
  missed: 'missed',
  ended: 'ended',
  recall: 'recall',
  handled: 'handled',
};
